import React, { Component } from 'react';
import DropdownMaster from '../DropdownMaster';
import FpgMinusIcon from '../../icons/fpgminusicon';
import { PAGE_TAKEOVER_CONDITION_TYPES as CONDITION_TYPES, PT_CONDITION_TYPE } from '../../cosntants';

export default class ConditionBlock extends Component {

    handleTypeChange = (e) => {
        this.props.onChange(this.props.index, 'condition', e.target.value);
    }

    handleValueChange = (e) => {
        let value = e.target.value;
        if (e.target.type === 'text') {
            value = value.replace(/^\s+/, '');
        }
        this.props.onChange(this.props.index, 'targetId', value);
    }

    getPlaceholder = () => {
        switch (this.props.condition) {
            case PT_CONDITION_TYPE.COMPONENT_CLICKED:
                return 'Enter DOM element ID';
            case PT_CONDITION_TYPE.EVENT_FIRED:
                return 'Enter event name';
            default:
                return '';
        }
    }

    render() {
        const { index, condition, targetId, canRemove, error } = this.props;

        return (
            <div className="condition_block">
                <div className="condition_block_header d_flex d_flex_align_center d_flex_justify_spacebt">
                    <span className="condition_block_title">Condition #{index + 1}</span>
                    {canRemove &&
                        <span className="condition_block_remove" onClick={() => this.props.onRemove(index)}>
                            <FpgMinusIcon className="pointer" width="20" height="20" color="#000000" stroke="#fff" />
                        </span>
                    }
                </div>
                <div className="condition_block_body">
                    <div className="field_row_inner">
                        <DropdownMaster
                            label="Condition Type"
                            name="condition"
                            options={CONDITION_TYPES}
                            value={condition}
                            onChange={this.handleTypeChange}
                        />
                    </div>
                    {condition !== PT_CONDITION_TYPE.PAGE_LOADED &&
                        <div className="field_row_inner">
                            <label className="required">Value</label>
                            <div className="field_input">
                                <input
                                    type="text"
                                    value={targetId}
                                    onChange={this.handleValueChange}
                                    placeholder={this.getPlaceholder()}
                                    autoComplete="off"
                                />
                                {error && <span className="error">{error}</span>}
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}
